import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";

export function GelItem(props) {

  return (
    <li
      style={{
        width: "calc(100% - 8px)",
        height: "19px",
        margin: "0 4px",
        background: "#0063C3",
        transform: "translateY(" + ((props.offset === -55)?-43:(props.offset * 0.6031168831)) + "px)",
        position: "absolute",
        zIndex: 99 - props.id
      }}
    >
      <p
        style={{ color: "white", textAlign: "center", margin: 0 }}
        tabIndex={0}
      >
        {/*props.id*/}
      </p>
    </li>
  );
}
GelItem.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  setOffset: PropTypes.function,
  offset: PropTypes.float,
};

export default function Gel(props) {

  const height = 120;
  const range = [0, 1000];
  const ticks = [100, 300, 500, 800, 1000];
  const [lanes, setLanes] = useState({
    "DNA Ladder": [100, 300, 500, 800, 1000],
    Sample: [-55, -55],
    "Control 1": [-55, -55],
    "Control 2": [-55, -55],
    "Control 3": [-55, -55],
    "Control 4": [-55, -55],
  });

  const getTicks = (ticks) => {
    ticks = ticks
      .sort((a, b) => {
        return a - b;
      })
      .reverse();

    return (
      <ul
        style={{ position: "relative", width: "68px", height: height + "px" }}
      >
        {ticks.map((tick, index) => (
          <li
            style={{
              position: "absolute",
              bottom:
                20 + (height / (range[1] - range[0])) * tick - 20 + "px",
            }}
          >
            {tick + " bp"}
          </li>
        ))}
      </ul>
    );
  };

  const getLadder = (ticks) => {
    ticks = ticks
      .sort((a, b) => {
        return a - b;
      })
      .reverse();

    return (
      <ul
        style={{ position: "relative", height: height, padding: "20px 0" }}
      >
        {ticks.map((tick, index) => (
          <li
            style={{
              position: "absolute",
              bottom:
                20 + (height / (range[1] - range[0])) * tick - 20 + "px",
              width: "calc(100% - 8px)",
              height: "19px",
              margin: "0 4px",
            }}
          >
            <div style={{background: "#003E6B", opacity: "0.5", width: "100%", height: "100%"}}></div>
          </li>
        ))}
      </ul>
    );
  };

  const renderGel = (lanes, ticks) => {

    return (
      <ul
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
        }}
      >
      <li style={{ color: "white", height: height + "px" }}>
        {getTicks(ticks)}
      </li>
      {Object.keys(lanes).map((lane, index) => (
        <li
          style={{
            width:
              "calc(" +
              100 / (Object.keys(lanes).length - 1) +
              "% - " +
              105 / (Object.keys(lanes).length - 1) +
              "px)",
          }}
        >
          <p style={{ color: "white", textAlign: "center", writingMode: "vertical-lr", margin: "0 auto 8px auto"}}>{lane}</p>
          <div
            style={{ height: "19px", background: "#99DFF9", padding: "4px 4px" }}
          >
            <div style={{
              background: "#79C4E0",
              border: "1px solid #003E6B",
              boxSizing: "border-box",
              width: "100%",
              height: "19px"
            }}>
            </div>
          </div>
          <div
            style={{ height: (height + 40) + "px", background: "#99DFF9" }}
          >
            {
              (lane === "DNA Ladder")?(
                getLadder(ticks)
              ):(
                <ul style={{ position: "relative", padding: "20px 0" }}>
                  {lanes[lane].map((offset, bandIndex) => {
                    return offset !== null ? (
                      <GelItem
                        type={lane}
                        id={bandIndex + 1}
                        offset={offset}
                      />
                    ) : null;
                  })}
                </ul>
              )
            }
          </div>
        </li>
      ))}
      </ul>
    )
  }

  return (
    <div>
      {renderGel((props.lanes)?props.lanes:lanes, ticks)}
    </div>
  );
}
Gel.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  dragdrop: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

Gel.defaultProps = {

};
